import { render, staticRenderFns } from "./ModalRincian.vue?vue&type=template&id=6a1292dd&scoped=true&"
import script from "./ModalRincian.vue?vue&type=script&lang=js&"
export * from "./ModalRincian.vue?vue&type=script&lang=js&"
import style0 from "./ModalRincian.vue?vue&type=style&index=0&id=6a1292dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1292dd",
  null
  
)

export default component.exports